import { render, staticRenderFns } from "./GraveyardsTable.vue?vue&type=template&id=89718b34"
import script from "./GraveyardsTable.vue?vue&type=script&lang=js"
export * from "./GraveyardsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports